import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import NavBar from "./components/NavBar.js";
import Routes from "./components/Routes.js";
import { useUser } from "./components/UserContext.js";
import { useLocales } from "./lib/hooks/useLocales.js";
import theme from "./styles/muiTheme.js";

export default function App() {
  const { isLoggedIn } = useUser();
  const { locales } = useLocales();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isLoggedIn ? <NavBar locales={locales} /> : null}
      <Container
        component="main"
        maxWidth="lg"
        sx={{ mx: "auto", px: 2, sm: { px: 3 }, lg: { px: 4 } }}
      >
        <Routes locales={locales} />
      </Container>
    </ThemeProvider>
  );
}
